import { render, staticRenderFns } from "./view-application.vue?vue&type=template&id=0000ca67&scoped=true"
import script from "./view-application.vue?vue&type=script&lang=js"
export * from "./view-application.vue?vue&type=script&lang=js"
import style0 from "./view-application.vue?vue&type=style&index=0&id=0000ca67&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0000ca67",
  null
  
)

export default component.exports